import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.66634 4.16797V14.168C3.66634 14.5362 3.96482 14.8346 4.33301 14.8346H11.6663C12.0345 14.8346 12.333 14.5362 12.333 14.168V4.16797M3.66634 4.16797H12.333M3.66634 4.16797H2.33301M12.333 4.16797H13.6663M9.66634 7.66797V11.5013M6.33301 7.66797V11.5013M5.99967 4.16797C5.99967 3.0634 6.89511 2.16797 7.99967 2.16797C9.10424 2.16797 9.99967 3.0634 9.99967 4.16797",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }